exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-posts-markdown-remark-fields-slug-tsx": () => import("./../../../src/pages/posts/{markdownRemark.fields__slug}.tsx" /* webpackChunkName: "component---src-pages-posts-markdown-remark-fields-slug-tsx" */)
}

